import React from 'react';
import Footers from '../Footers/Footer'
import { Container, Card, Button } from 'react-bootstrap';
import { Link, Redirect } from "react-router-dom";
import Headers from '../Headers/Headers';
//import Parser from 'html-react-parser';

function closeHandler()  { 
    window.open('','_parent','');
    window.close();     
    }

const Result = props => {
    
    let body = 'Loading...'
    let redirectMsg = null
    const userid = localStorage.getItem('id')
    console.log(props.location.state)

    if (props.location.state) {
        if(props.location.state.userType === "Student") {       
            if(userid) {
                redirectMsg = (
                    <p>Please log out before closing the window. </p>
                )
            } else {
                redirectMsg = (
                    <p>Please close this window. </p>
                )
            }             
        } else {
            redirectMsg = (
                <p>Please refer to the <Link to={
                    {
                        pathname: "/PhotoGuide",
                        state: {
                            studentID: props.location.state.studentID,
                            userType: props.location.state.userType,
                            accesstoken: props.location.state.accesstoken,
                            staffName: props.location.state.staffName
                        }
                    }
                }>guidelines</Link> or click <Link to={
                    {
                        pathname: "/Upload",
                        state: {
                            studentID: props.location.state.studentID,
                            userType: props.location.state.userType,
                            accesstoken: props.location.state.accesstoken,
                            staffName: props.location.state.staffName
                        }
                    }
                }>here</Link> to return to upload page. </p>
            )
        }
        if (props.location.state.uploadStatus) {
            body = (
                <div className="text-center">
                    <p>Your photo has been successfully uploaded.</p>
                    <p>RP may contact you if they need you to resubmit your photo.</p>
                    {redirectMsg}
                </div>

            );
        } else {
            // let photoguidelinesreplacetext = <Link to={{pathname: "/PhotoGuide",state: {studentID: props.location.state.studentID,userType: props.location.state.userType,accesstoken: props.location.state.accesstoken,staffName: props.location.state.staffName}}}>guidelines</Link>
            // let photoguidelinereplacetext = <Link to={{pathname: "/PhotoGuide",state: {studentID: props.location.state.studentID,userType: props.location.state.userType,accesstoken: props.location.state.accesstoken,staffName: props.location.state.staffName}}}>guideline</Link>
            const uniqueRemarks = []
            props.location.state.uploadRemarks.split(',').map(rem => {
                if (uniqueRemarks.indexOf(rem) === -1) {
                    uniqueRemarks.push(rem.replace('|',','))
                }
            });
            body = (
                <div>
                    <h5>These are the possible reasons for failure:</h5>
                    <ul>    
                        {uniqueRemarks.map(element => {
                            if (element !== "Success" || element !== '') {
                                // if(element.indexOf("guidelines")!=-1)
                                // {
                                //     return <li key={element}>{element.substring(0,element.indexOf("guidelines"))} {photoguidelinesreplacetext}
                                //         {element.substring(element.indexOf("guidelines")+10,element.length )}</li>
                                // }
                                // else if(element.indexOf("guideline")!=-1)
                                // {
                                //     return <li key={element}>{element.substring(0,element.indexOf("guideline"))} {photoguidelinereplacetext}
                                //         {element.substring(element.indexOf("guideline")+9,element.length )}</li>
                                // }
                                // else
                                // {
                                    //return <div dangerouslySetInnerHTML={{__html:<li key={element}>{element}</li>}} />  
                                    //return <div>Parser(element)</div>
                                    //let htmlFromBackend = `<b>Hello there</b>, partner!`

return (
  <li><div dangerouslySetInnerHTML={{ __html: element }} /></li>
)
                            }
                        })}
                    </ul>
                    <p>Please refer to the <Link to={
                    {
                        pathname: "/PhotoGuide",
                        state: {
                            studentID: props.location.state.studentID,
                                userType: props.location.state.userType,
                                accesstoken: props.location.state.accesstoken,
                                staffName: props.location.state.staffName,
                                role: props.location.state.role
                        }
                    }
                }>guidelines</Link> or click <Link to={
                        {
                            pathname: "/Upload",
                            state: {
                                studentID: props.location.state.studentID,
                                userType: props.location.state.userType,
                                accesstoken: props.location.state.accesstoken,
                                staffName: props.location.state.staffName,
                                role: props.location.state.role
                            }
                        }
                    }>here</Link> to return to upload page. </p>
                </div>
            )
        }

        return (
            <div>
                <Headers user={userid} />
                <Container className="col-md-6">
                    <Card className="mt-5">
                        <Card.Header className="bg-brandcolor text-center">
                            <h5 className="text-white">Result</h5>
                        </Card.Header>
                        <Card.Body>
                            {body}
                        </Card.Body>
                    </Card>
                </Container>
                <Footers />
            </div>
        );
    } else {
        return (
            // <Redirect to='/' />
            <div>
                <Headers user={userid} />
                <Container className="col-md-6">
                    <Card className="mt-5">
                        <Card.Header className="bg-brandcolor text-center">
                            <h5 className="text-white">Result</h5>
                        </Card.Header>
                        <Card.Body>
                            {body}
                        </Card.Body>
                    </Card>
                </Container>
                <Footers />
            </div>
        )

    }

}

export default Result;
